import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { RadioGroup, RadioButton } from 'react-radio-buttons';

import RenderIf from '../../render-if/components/render-if';
import constants from '../../../../common/constants';

class RadioButtonGroup extends Component {
  renderRadioButtons(options) {
    const { t } = this.context;

    if (options && options.length > 0) {
      return options.map((item, index) => {
        return (
          <RadioButton value={item.value} disabled={item.disabled} iconSize={item.size || 20} key={index} className="radio-button">
            <RenderIf if={item.pre_label}>
              <strong>{t(item.pre_label)}</strong>
            </RenderIf>
            <RenderIf if={item.label}>
              <span>{t(item.label)}</span>
            </RenderIf>
          </RadioButton>
        );
      });
    } else return null;
  }

  render() {
    const { value, label, customClass, options, onChange, type } = this.props;
    const { t } = this.context;

    return (
      <div className={`radio-button-group ${customClass ? customClass : ''}`}>
        <label>{t(label)}</label>
        <RenderIf if={!type || type === constants.radio_button_types.horizontal}>
          <RadioGroup onChange={onChange} value={value || ''} horizontal>
            {this.renderRadioButtons(options)}
          </RadioGroup>
        </RenderIf>
        <RenderIf if={type === constants.radio_button_types.vertical}>
          <RadioGroup onChange={onChange} value={value || ''}>
            {this.renderRadioButtons(options)}
          </RadioGroup>
        </RenderIf>
      </div>
    );
  }
}

RadioButtonGroup.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(state => ({
  lang: state.i18nState.lang,
}))(RadioButtonGroup);



// WEBPACK FOOTER //
// ./src/app/shared/radio-button-group/components/radio-button-group.js